<div class="message-modal message-modal--accept-agb">
    <img alt="" aria-hidden="true" class="header-image" src="/assets/images/illustration-58.svg">
    <h1 class="title" i18n="@@popup.acceptAgb.title" id="modal-title">Neue AGB und DSE</h1>
    <p class="body" i18n="@@popup.acceptAgb.text">Liebe*r Nutzer*in wir haben die AGB und DSE aktualisiert. Bitte
        akzeptieren Sie die Änderungen um fortzufahren.</p>

    <p class="message-modal__checkbox">
        <label class="custom-checkbox">
            <input [(ngModel)]="agb" [ngModelOptions]="{standalone: true}" type="checkbox"/>
            <span i18n="@@popup.acceptAgb.agbCheckbox"><a [href]="linkToAGB" target="_blank">AGB</a> akzeptiere</span>
        </label>
    </p>
    <p class="message-modal__checkbox">
        <label class="custom-checkbox">
            <input [(ngModel)]="dse" [ngModelOptions]="{standalone: true}" type="checkbox"/>
            <span i18n="@@popup.acceptAgb.dseCheckbox"><a [href]="linkToDSE" target="_blank">DSE</a> akzeptiere</span>
        </label>
    </p>

    <div class="action">
        <button (click)="ok()" [disabled]="!acceptedAll" class="button primary" i18n="@@popup.acceptAgb.accept">Fertig
        </button>
    </div>
</div>
